/**
 * Whether `version` is older than `minimum`, comparing dot-separated numeric parts.
 * An empty or unparsable `minimum` means no minimum is set.
 */
export function isOlderThan(version: string, minimum: string): boolean {
    const min = parseVersion(minimum);
    const current = parseVersion(version);
    if (!min || !current) {
        return false;
    }

    for (let i = 0; i < Math.max(min.length, current.length); i++) {
        const a = current[i] ?? 0;
        const b = min[i] ?? 0;
        if (a !== b) {
            return a < b;
        }
    }
    return false;
}

function parseVersion(version: string): number[] | undefined {
    const parts = version.trim().split(".");
    if (!parts.every((part) => /^\d+$/.test(part))) {
        return undefined;
    }
    return parts.map(Number);
}
